import * as React from 'react';
import './Navbar.css';
import { Link, Redirect } from "react-router-dom";
import i18n from 'i18next';

interface Props {
   lang: string,
   cc: string
}
const Navbar = ({
   lang, cc
}: Props) => {

   return (
      <div className="nav-main">
         <div>
            <div className="select-container">
               <Link to={'/mktinfo?lang=' + lang + '&cc=' + cc}>{i18n.t('Home.Title')}</Link>
            </div>
            <div className="select-container">
               <Link className="border" to={'/chart?lang=' + lang + '&cc=' + cc}>{i18n.t('Chart.Title')}</Link>
            </div>
            <div className="select-container">
               <Link className="border" to={'/news?lang=' + lang + '&cc=' + cc}>{i18n.t('News.Menu.FXNews')}</Link>
            </div>
            <div className="select-container">
               <Link className="border" to={'/commentary?lang=' + lang + '&cc=' + cc}>{i18n.t('Commentary.Title')}</Link>
            </div>
            <div className="select-container">
               <Link className="border" to={'/fxpolls?lang=' + lang + '&cc=' + cc}>{i18n.t('FXPolls.Title')}</Link>
            </div>
            {/* <div className="select-container">
               <Link className="border" to={'/calendar?lang=' + lang + '&cc=' + cc}>{i18n.t('Calendar.Title')}</Link>
            </div> */}
          
         </div>
      </div>
   )
}
export default Navbar;